var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DrugbookEntries',{attrs:{"status":"all"}})
}
var staticRenderFns = []

export { render, staticRenderFns }